import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import vuetify from './plugins/vuetify'
import './base'

import { 
	CHECK_AUTH
} from "./store/actions.type";

// Checking Auth 


/* eslint-disable */
router.beforeEach((to, from, next) => {
	if(!store.state.account.isLogedIn) {
		Promise.all([store.dispatch(CHECK_AUTH)])
		.then(next)
	} else {
		next()
	}
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
